<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div class="pt-6" style="min-height: calc(100vh - 135px)">
          <Menu :selectedKeys="[8]"></Menu>
        </div>
      </div>
      <div class="float-right p-6" style="width: calc(100% - 128px)">
        <a-spin :spinning="spinning">
          <div>
            <div class="query-bar pb-6">
              <div class="query-item">
                <span class="pr-2 leading-8">申请人:</span>
                <a-input
                  style="width: 200px"
                  v-model="queryParam.like.bidder"
                  placeholder="请输入申请人"
                  @pressEnter="press_enter"
                ></a-input>
              </div>
              <div class="query-item">
                <span class="pr-2 leading-8">保函编号:</span>
                <a-input
                  style="width: 200px"
                  v-model="queryParam.like.code"
                  placeholder="请输入保函编号"
                  @pressEnter="press_enter"
                ></a-input>
              </div>
              <div class="query-item">
                <span class="pr-2 leading-8">开标日期:</span>
                <a-range-picker
                  v-model="queryParam.time['a.kbdate']"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                />
              </div>
              <div class="query-item">
                <span class="pr-2 leading-8">下单日期:</span>
                <a-range-picker
                  v-model="queryParam.time['a.create_time']"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                />
              </div>
              <div class="query-item">
                <a-button type="primary" class="mr-2" @click="gets(1)">搜索</a-button>
                <a-button type="default" @click="reset">重置</a-button>
              </div>
              <div class="query-actions">
                <a-button
                  type="primary"
                  @click="exportbilling"
                  >导出报表</a-button
                >
              </div>
            </div>
            <a-table
              :loading="loading"
              :columns="columns"
              :data-source="list"
              :pagination="pagination"
              bordered
              row-key="id"
              size="small"
              class="liaoning-report-table"
              ><template slot="code" slot-scope="text, record">
                <text-highlight :queries="[queryParam.like.code]" :title="text">
                  {{ (record.prefix || '') + (text || '') }}</text-highlight
                >
              </template>
              <template slot="de_toubaono" slot-scope="text, record">
                {{ text || record.toubaono || '' }}
              </template>
              <template slot="bidder" slot-scope="text">
                <text-highlight :queries="[queryParam.like.bidder]" :title="text">
                  {{ text }}</text-highlight
                >
              </template>
              <template slot="project" slot-scope="text">
                <span class="project-cell" :title="text">{{ text }}</span>
              </template>
            </a-table>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>
<script>
  import Menu from '@/views/admin/menu/index.vue';
  import { columns } from './_list';
  import { contracts_liaoning, exportContractLiaoning } from '@/api/contract';
  import permission from '@/utils/permission';
  import { downloadUrl } from '@/utils/download';

  export default {
    components: {
      Menu,
    },
    data() {
      return {
        columns,
        queryParam: this.getDefaultQueryParam(),
        pagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '50'],
          showSizeChanger: true,
          hideOnSinglePage: true,
          onChange: (page, pageSize) => {
            this.pagination.current = page;
            this.pagination.pageSize = pageSize;
            if (this.searched) {
              this.gets();
            }
          },
          onShowSizeChange: (current, size) => {
            this.pagination.current = current;
            this.pagination.pageSize = size;
            if (this.searched) {
              this.gets();
            }
          },
          showTotal: (total) => this.formatTotalText(total),
        },
        list: [],
        loading: false,
        spinning: false,
        searched: false,
        totalPoundage: 0,
      };
    },
    methods: {
      permission,
      getDefaultQueryParam() {
        return {
          like: {
            bidder: '',
            code: '',
          },
          time: {
            'a.kbdate': undefined,
            'a.create_time': undefined,
          },
        };
      },
      getCustomTime() {
        return {
          kbdate: this.queryParam.time['a.kbdate'],
          create_time: this.queryParam.time['a.create_time'],
        };
      },
      async gets(current) {
        this.loading = true;
        this.searched = true;
        if (current) {
          this.pagination.current = current;
        }
        try {
          let res = await contracts_liaoning({
            current: this.pagination.current,
            pageSize: this.pagination.pageSize,
            qp: JSON.stringify(this.queryParam),
            custom_time: JSON.stringify(this.getCustomTime()),
          });
          this.totalPoundage = res.sum || 0;
          this.list = res.data || [];
          this.$set(this.pagination, 'total', res.total);
        } finally {
          this.loading = false;
        }
      },
      reset() {
        this.queryParam = this.getDefaultQueryParam();
        this.list = [];
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.totalPoundage = 0;
        this.$set(this.pagination, 'total', 0);
        this.searched = false;
      },
      formatTotalText(total) {
        if (!total) {
          return '';
        }
        return `合计担保费: ${this.totalPoundage}元 | 共 ${total} 条数据`;
      },
      press_enter(e) {
        e.preventDefault();
        this.gets(1);
      },
      buildExportParams() {
        const kbdate = this.queryParam.time['a.kbdate'];
        if (!Array.isArray(kbdate) || kbdate.length !== 2) {
          this.$message.warning('请选择开标日期');
          return null;
        }
        return {
          qp: JSON.stringify(this.queryParam),
          custom_time: JSON.stringify(this.getCustomTime()),
        };
      },
      getDownloadUrl(url) {
        if (/^https?:\/\//.test(url)) {
          return url;
        }
        return this.$ossUrl.replace(/\/$/, '') + '/' + String(url || '').replace(/^\//, '');
      },
      async exportbilling() {
        const params = this.buildExportParams();
        if (!params) {
          return;
        }
        this.spinning = true;
        try {
          const url = await exportContractLiaoning(params);
          await downloadUrl(this.getDownloadUrl(url), '辽宁对接平台报表列表.xlsx');
          this.$message.success('导出成功');
        } catch (error) {
          this.$message.error('报表导出失败:' + (error.message || error));
        } finally {
          this.spinning = false;
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .query-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px 24px;
  }

  .query-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .query-actions {
    margin-left: auto;
  }

  :deep(.liaoning-report-table .ant-table-fixed),
  :deep(.liaoning-report-table .ant-table-fixed-left table),
  :deep(.liaoning-report-table .ant-table-fixed-right table) {
    table-layout: fixed;
  }

  :deep(.liaoning-report-table .ant-table-tbody > tr > td),
  :deep(.liaoning-report-table .ant-table-thead > tr > th) {
    white-space: nowrap;
  }

  .project-cell {
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
